var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedGrainsV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white",
    fillOpacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92577 16.7501C5.10077 16.7501 4.76952 15.2751 4.70077 14.6876C4.62675 14.1172 4.69547 13.5373 4.90077 13.0001C4.991 12.7444 5.1462 12.5166 5.35111 12.3391C5.55603 12.1616 5.80361 12.0404 6.06952 11.9876C6.80077 11.8626 7.31952 12.3001 7.98202 12.4501C8.10647 12.49 8.23914 12.497 8.3671 12.4704C8.49507 12.4438 8.61395 12.3845 8.71215 12.2982C8.81036 12.212 8.88454 12.1018 8.92745 11.9783C8.97037 11.8548 8.98055 11.7224 8.95702 11.5938C8.68202 10.5188 6.72577 10.5001 5.92577 10.5001C5.92577 9.33757 7.20077 9.18757 8.11327 9.27507C8.6546 9.32735 9.18763 9.44487 9.70077 9.62507C10.0133 9.73132 10.3758 10.0001 10.7195 9.97507C11.2383 9.93132 11.3445 9.39382 11.1195 9.00007C10.5758 8.07507 9.03202 8.00007 8.11327 8.00007C8.11327 6.75007 9.19452 6.51257 10.232 6.70007C10.7677 6.80542 11.2898 6.97106 11.7883 7.19382C12.107 7.33132 12.4883 7.59382 12.8383 7.47507C13.7383 7.20007 12.8008 6.23757 12.4008 6.00632C12.12 5.8514 11.8222 5.72975 11.5133 5.64382C11.1758 5.54382 10.7633 5.58132 11.0695 5.18757C11.5484 4.76508 12.1425 4.49521 12.7758 4.41257C13.957 4.13757 15.5883 4.08757 15.8758 5.57507C15.9716 6.36041 15.7831 7.15411 15.3445 7.81257C14.1802 9.80422 12.7387 11.6203 11.0633 13.2063C10.1759 14.116 9.21421 14.9501 8.18827 15.7001C7.56327 16.1501 6.73827 16.7501 5.92577 16.7501Z",
    fill: "#FF9300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedGrainsV2);
export default __webpack_public_path__ + "static/media/rounded-grains-v2.de0477c07462a64247e511038caa68ce.svg";
export { ForwardRef as ReactComponent };